<template>
  <div class="w-full">
    <Panel header="Văn bản gởi tổ dân phố">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
        <div class="flex min-w-0 flex-col md:col-span-3">
          <label>Tiêu đề</label>
          <InputText id="title" type="text" v-model="documentCreate.title" />
        </div>
        <div class="min-w-0 md:col-span-12">
          <label>Nội dung</label>
          <Textarea
              id="content"
              type="text"
              v-model="documentCreate.content"
              placeholder="Nhập nội dung"
              class="min-h-[112px]"
          />
        </div>
        <section class="md:col-span-12">
          <div
              class="rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div
                class="mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-3"
            >
              <div>
                <label class="m-0 text-[15px] font-bold text-slate-900">
                  Tập tin PDF
                </label>
                <div class="mt-1 text-[13px] font-medium text-slate-500">
                  Chỉ chấp nhận file PDF
                </div>
              </div>

              <div
                  class="inline-flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-slate-700"
              >
                <i class="pi pi-file-pdf"></i>
                <span>Cho phép chọn nhiều file</span>
              </div>
            </div>

            <div
                class="grid grid-cols-1 gap-3 lg:grid-cols-[minmax(0,1fr)_auto]"
            >
              <div
                  class="flex min-w-0 items-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5"
              >
                <span
                    class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-red-50 text-red-700"
                >
                  <i class="pi pi-file-pdf"></i>
                </span>

                <div class="min-w-0">
                  <div
                      class="truncate text-[15px] font-semibold text-slate-900"
                  >
                    {{
                      listFileName.length > 0
                          ? `Đã chọn ${listFileName.length} tập tin`
                          : "Chưa chọn tập tin"
                    }}
                  </div>

                  <div class="text-sm text-slate-500">
                    Có thể chọn nhiều PDF cùng lúc
                  </div>
                </div>
              </div>

              <div class="flex shrink-0 flex-wrap gap-2 lg:justify-end">
                <Button
                    outlined
                    label="Chọn PDF"
                    icon="pi pi-paperclip"
                    @click="triggerFilePicker"
                    :disabled="loadingBar"
                />

<!--                <Button-->
<!--                    label="Tải lên"-->
<!--                    icon="pi pi-cloud-upload"-->
<!--                    @click="upload"-->
<!--                    :loading="loadingBar"-->
<!--                    :disabled="loadingBar || listFileName.length < 1"-->
<!--                />-->
              </div>
            </div>
          </div>

          <form enctype="multipart/form-data">
            <input
                ref="fileInputEl"
                type="file"
                class="hidden"
                accept=".pdf"
                multiple
                @change="fileChange($event.target.files)"
                :disabled="loadingBar"
            />
          </form>
        </section>

        <section class="md:col-span-12">
          <div
              class="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div
                class="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-3"
            >
              <div>
                <div class="text-[15px] font-bold text-slate-900">
                  Danh sách PDF
                </div>

                <div class="text-[13px] font-medium text-slate-500">
                  Kiểm tra trước khi tải lên.
                </div>
              </div>
            </div>

            <div v-if="listFileName.length > 0" class="overflow-x-auto">
              <table class="min-w-full divide-y divide-slate-200 text-[15px]">
                <thead
                    class="bg-slate-100 text-left text-xs font-bold uppercase text-slate-600"
                >
                <tr>
                  <th class="px-4 py-3">Tên file</th>
                  <th class="w-36 px-4 py-3">Dung lượng</th>
                  <th class="w-28 px-4 py-3 text-right">Thao tác</th>
                </tr>
                </thead>

                <tbody class="divide-y divide-slate-100 bg-white">
                <tr
                    v-for="file in listFileName"
                    :key="file.nameFile"
                    class="transition hover:bg-red-50/30"
                >
                  <td class="px-4 py-3">
                    <div class="flex min-w-0 items-center gap-3">
                        <span
                            class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-red-50 text-red-700"
                        >
                          <i class="pi pi-file-pdf"></i>
                        </span>

                      <span class="truncate">
                          {{ file.nameFile }}
                        </span>
                    </div>
                  </td>

                  <td>
                    {{ formatFileSize(file.value?.size) }}
                  </td>

                  <td class="text-right px-4 py-3">
                    <Button
                        severity="danger"
                        label="Xóa"
                        icon="pi pi-trash"
                        @click="deleteFile(file.nameFile)"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="px-4 py-8 text-center">
              <i class="pi pi-file-pdf text-4xl text-slate-300"></i>

              <p class="mt-3 text-sm font-semibold text-slate-600">
                Chưa có PDF nào được chọn
              </p>
            </div>
          </div>
        </section>
        <section class="md:col-span-12">
          <div
              class="rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div
                class="mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-3"
            >

              <div
                  class="inline-flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-slate-700"
              >
                <i class="pi pi-file-pdf"></i>
                <span>Chọn người gời thông báo</span>
              </div>
            </div>

            <div
                class="grid grid-cols-1 gap-3 lg:grid-cols-[minmax(0,1fr)_auto]"
            >
              <div
                  class="flex min-w-0 items-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5"
              >
                <span
                    class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-red-50 text-red-700"
                >
                  <i class="pi pi-file-pdf"></i>
                </span>
<!--                <div class="w-full">-->
<!--                  <Panel header="Văn bản gởi tổ dân phố">-->
<!--                    <div class="grid grid-cols-1 gap-4 md:grid-cols-12">-->
<!--                <div class="min-w-0">-->
                  <div class="w-full">
                    <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                      <div class="flex min-w-0 flex-col md:col-span-3">
                        <label>Lựa chọn nhóm</label>
                        <Dropdown
                            id="group"
                            v-model="groupUser"
                            :options="userPermission"
                            optionLabel="label"
                            optionValue="value"
                            @change="selectGroup"
                        >
                        </Dropdown>
                      </div>
                      <div class="flex min-w-0 flex-col md:col-span-3">
                        <label>Chọn khách hàng gởi</label>
                        <MultiSelect
                            v-model="sendDocument.listId"
                            :options="listUser"
                            optionLabel="fullname"
                            optionValue="id"
                            placeholder="Chọn tài khoản"
                            :filter="true"
                        >
                        </MultiSelect>
                      </div>
                    </div>
<!--                  </div>-->
                </div>
              </div>

              <div class="flex shrink-0 flex-wrap gap-2 lg:justify-end">
                <Button
                    label="Gởi thông báo"
                    icon="pi pi-cloud-upload"
                    @click="upload"
                    :loading="loadingBar"
                    :disabled="loadingBar || listFileName.length < 1"
                />
              </div>
            </div>
          </div>

          <form enctype="multipart/form-data">
            <input
                ref="fileInputEl"
                type="file"
                class="hidden"
                accept=".pdf"
                multiple
                @change="fileChange($event.target.files)"
                :disabled="loadingBar"
            />
          </form>
        </section>
      </div>
    </Panel>

    <Dialog header="Đang tải PDF" v-model:visible="loadingBar">
      <div>
        <label>Đang tải tài liệu lên máy chủ...</label>
        <ProgressBar mode="indeterminate" />
      </div>
    </Dialog>
  </div>
</template>

<script lang="ts">
import { ref } from "vue";
import axios from "axios";
import { useToast } from "@/ui/services/toast";
import {Document} from "postcss";
import {DocumentCreate} from "@/models/documentCreate";
import zaloRepository from "@/services/ZaloRepository";
import {DocumentObject} from "@/models/documentObject";
import {User} from "@/models/user";
import SendDocument from "@/models/sendDocument";

export default {
  props: {
    id: String,
  },

  setup(props) {
    const toast = useToast();

    const loadingBar = ref(false);

    const fileInputEl = ref<HTMLInputElement | null>(null);

    const listFileName = ref<any[]>([]);
    const documentCreate = ref({} as DocumentCreate);
    const documentObject = ref({} as DocumentObject);
    const userPermission = ref([
      { label: "Tất cả", value: "all" },
      { label: "Tài khoản cấp tổ", value: "civilGroup" },
      { label: 'Tài khoản cấp phường', value: 'ward' },
      // { label: 'Tài khoản cấp quận', value: 'district' },
      { label: "Quản lý", value: "admin" },
    ]);
    const groupUser = ref("");
    const sendDocument = ref({} as SendDocument);
    const listUser = ref([] as User[]);

    const triggerFilePicker = () => {
      fileInputEl.value?.click();
    };

    const fileChange = (fileList: FileList) => {
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];

        if (
            file.type !== "application/pdf" &&
            !file.name.toLowerCase().endsWith(".pdf")
        ) {
          toast.add({
            severity: "warn",
            summary: "Không hợp lệ",
            detail: `${file.name} không phải PDF`,
            life: 3000,
          });

          continue;
        }

        const existed = listFileName.value.some(
            (x) => x.nameFile === file.name
        );

        if (existed) continue;

        listFileName.value.push({
          nameFile: file.name,
          value: file,
        });
      }
    };

    const deleteFile = (name: string) => {
      listFileName.value =
          listFileName.value.filter(
              (x) => x.nameFile !== name
          );
    };

    const formatFileSize = (size?: number) => {
      if (!size) return "";

      if (size < 1024)
        return `${size} B`;

      if (size < 1024 * 1024)
        return `${(size / 1024).toFixed(1)} KB`;

      return `${(size / 1024 / 1024).toFixed(1)} MB`;
    };

    const upload = async () => {
      try {
        loadingBar.value = true;

        const response = await zaloRepository.createDocument(
            documentCreate.value
        );

        documentObject.value = response.data;
        sendDocument.value.idDocument = documentObject.value.id;

        const formData = new FormData();

        listFileName.value.forEach((file) => {
          formData.append(
              "formFiles",
              file.value,
              file.nameFile
          );
        });

        await axios.post(
            `/api/file/UploadFileDocument/${documentObject.value.id}`,
            formData,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            }
        );

        zaloRepository
            .sendDocumentForUser(sendDocument.value)
            .then((response) => {
            })
            .catch((err) => {
              // toast.add({
              //   severity: "error",
              //   summary: "Lỗi",
              //   detail: err.response.data,
              //   life: 2000,
              // });
            });
        toast.add({
          severity: "success",
          summary: "Thành công",
          detail: "Gởi văn bản thành công",
          life: 3000,
        });

        listFileName.value = [];
      } catch (err: any) {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail:
              err.response?.data ||
              err.message ||
              "Không thể tải PDF",
          life: 3000,
        });
      } finally {
        loadingBar.value = false;
      }
    };

    const selectGroup = () => {
      console.log(
          "################### selectGroup idGroupDelete: " + groupUser.value,
      );
      if (groupUser.value != "")
        zaloRepository
            .listUserByGroup(groupUser.value)
            .then((response) => {
              listUser.value = response.data;
            })
            .catch((err) => {
              toast.add({
                severity: "error",
                summary: "Lỗi",
                detail: err.response.data,
                life: 2000,
              });
            });
    };
    return {
      upload,
      loadingBar,
      fileInputEl,
      triggerFilePicker,
      fileChange,
      deleteFile,
      listFileName,
      formatFileSize,
      documentCreate,
      userPermission,
      groupUser,
      listUser,
      selectGroup,
      sendDocument,
    };
  },
};
</script>